import { render, staticRenderFns } from "./m-jeff-bag.vue?vue&type=template&id=372febc5&scoped=true"
import script from "./m-jeff-bag.vue?vue&type=script&lang=js"
export * from "./m-jeff-bag.vue?vue&type=script&lang=js"
import style0 from "./m-jeff-bag.vue?vue&type=style&index=0&id=372febc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372febc5",
  null
  
)

export default component.exports